import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  CashSpecialIcon,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { DEFERRED_ORIGINATION_ROUTES, TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

/**
 * Deferred send intro. First visit keeps one start CTA. Returning adds
 * history and compose.
 */
export const LandingPage = memo(({ returning = false }: { returning?: boolean }) => {
  const { t } = useTranslation("deferred-origination");
  const { theme } = useStore();
  const navigate = useNavigate();

  const colorConfig = theme.whiteView;
  const {
    background,
    backgroundBtn,
    textColorBtn,
    bodyCopy,
    dropzoneColors,
    backgroundIcon,
  } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <div className={returning ? "landing-returning-title" : undefined}>
              <PageTitle
                highlight={
                  returning ? t("landing.returningGreeting") : t("landing.greeting")
                }
                highlightColor={TITLE_COLOR}
                secudnary={t("landing.subtitle")}
                secudnaryColor={TITLE_COLOR}
              />
            </div>
            <BodyCopy textColor={bodyCopy}>{t("landing.body")}</BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          {returning ? (
            <section className="fund-request-actions fund-request-actions--stack">
              <Button
                type="button"
                size="large"
                variant="outline"
                background={backgroundBtn}
                color={TITLE_COLOR}
                style={{ backgroundColor: background }}
                onClick={() => navigate(DEFERRED_ORIGINATION_ROUTES.HOME)}
              >
                {t("transactions.title")}
              </Button>
              <Button
                size="large"
                background={backgroundBtn}
                color={textColorBtn}
                onClick={() => navigate(DEFERRED_ORIGINATION_ROUTES.TRANSFER)}
              >
                {t("transactions.newTransfer")}
              </Button>
            </section>
          ) : (
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={() => navigate(DEFERRED_ORIGINATION_ROUTES.HOME)}
            >
              {t("landing.cta")}
            </Button>
          )}
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});

export const LandingReturningPage = () => <LandingPage returning />;
